import { FormInstance } from 'antd';
import { useEffect } from 'react';

import { CardExplorer } from '@page/explorer/explorer.style';

import { Input } from '@atom/form/input/input';
import { Text, Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { Form } from '@form/common.style';
import { isExist } from '@util/data/is-exist';

interface ExplorerAuthProps {
  form: FormInstance;
}

export const ExplorerAuth = ({ form }: ExplorerAuthProps) => {
  useEffect(
    () =>
      void (
        !isExist(form.getFieldValue(['headers', 'Authorization'])) &&
        form.setFieldValue(['headers', 'Authorization'], 'Bearer ')
      ),
    [],
  );

  return (
    <CardExplorer>
      <Title color={ColorEnum.Black100} level={5} mb={8} weight={400}>
        Authorization
      </Title>
      <Form form={form} layout='vertical'>
        <Form.Item
          name={['headers', 'Authorization']}
          label={
            <Text color={ColorEnum.Black30} level='s'>
              Bearer Token
            </Text>
          }
        >
          <Input placeholder='Bearer aEfsas...' />
        </Form.Item>
      </Form>
    </CardExplorer>
  );
};
